export const COUNTRIES_API = 'https://restcountries.com/v2';

export const REGIONS = ['Africa', 'Americas', 'Asia', 'Europe', 'Oceania'];
